// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { APICallGateComponent } from 'src/app/modules/shared/components/api-call-gate.component';
import {
  LocalizedDatePipe,
  LocalizedTimePipe,
  TimeFromNowPipe,
} from './pipes/localizedDate.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitizeHTML.pipe';
import { ClipboardService } from './services/clipboard.service';
import { SimpleNotificationService } from './services/simple-notification.service';

@NgModule({
  imports: [
    CommonModule,
    LocalizedDatePipe,
    LocalizedTimePipe,
    TimeFromNowPipe,
    APICallGateComponent,
    SanitizeHtmlPipe,
  ],
  providers: [
    LocalizedDatePipe,
    LocalizedTimePipe,
    TimeFromNowPipe,
    APICallGateComponent,
    SanitizeHtmlPipe,
    ClipboardService,
    SimpleNotificationService,
  ],
  exports: [
    LocalizedDatePipe,
    LocalizedTimePipe,
    TimeFromNowPipe,
    APICallGateComponent,
    SanitizeHtmlPipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
